import {
  getAccessModeHint,
  getGroupShareLink,
  getMessengerChannelLabel,
  resolveMessenger,
} from "./messengers";

export function getAccessMode() {
  return "group";
}

export function getAccessLabel() {
  return "Групповой";
}

export function getGroupShareLinkForContext(gameId, { userMessenger, gameMessenger } = {}) {
  const messengerId = resolveMessenger({
    userMessenger,
    gameMessenger,
  });
  return getGroupShareLink(gameId, messengerId);
}

export { getGroupShareLink, getAccessModeHint, getMessengerChannelLabel, resolveMessenger };

export function getProjectStatusFromSettings(gameSettings) {
  if (gameSettings?.hidden) return "hidden";
  if (gameSettings?.published) return "published";
  return "draft";
}

export function mergeGameSettings(existingSettings = {}, patch = {}) {
  return {
    private_access: patch.private_access ?? existingSettings.private_access ?? false,
    adult_content: Boolean(
      patch.adult_content ?? existingSettings.adult_content
    ),
    published: Boolean(patch.published ?? existingSettings.published),
    hidden: Boolean(patch.hidden ?? existingSettings.hidden),
    completion_text:
      patch.completion_text ?? existingSettings.completion_text ?? "",
    author_telegram:
      patch.author_telegram ?? existingSettings.author_telegram ?? "",
    allow_replay: patch.allow_replay ?? existingSettings.allow_replay ?? true,
    messenger: patch.messenger ?? existingSettings.messenger,
    contentType:
      patch.contentType ?? existingSettings.contentType,
  };
}

export function settingsFromProjectStatus(projectStatus, existingSettings = {}) {
  return mergeGameSettings(existingSettings, {
    published: projectStatus === "published",
    hidden: projectStatus === "hidden",
  });
}

export function getProjectStatusDisplay(settings) {
  if (settings?.hidden) {
    return { label: "Остановлен", tone: "stopped" };
  }
  if (settings?.published) {
    return { label: "Опубликован", tone: "published" };
  }
  return { label: "В работе", tone: "draft" };
}

export const ACCESS_MODE_HINT =
  "Сотрудники проходят сценарий по общей ссылке в выбранном мессенджере. Нужна активная бизнес-подписка по размеру команды.";

export const EXAMPLE_START_POST = {
  title: "Долг платежом красен",
  description:
    "Привет! Ты готов начать увлекательное приключение со мной?",
  posterSrc: `${process.env.PUBLIC_URL}/images/bg.png`,
};
